import { ChevronsLeft, ChevronsRight } from 'lucide-react'
import {
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
  Pagination as UIPagination,
} from '../ui/pagination'
import { Button } from '../ui/button'

export function Pagination({
  page,
  pageCount,
  onPageChange,
}: {
  page: number
  pageCount: number
  onPageChange: (p: number) => void
}) {
  return (
    <UIPagination>
      <PaginationContent>
        <PaginationItem>
          <Button
            variant="ghost"
            size="icon-sm"
            className={page <= 1 ? 'pointer-events-none opacity-50' : ''}
            onClick={() => onPageChange(1)}
            aria-label="Go to first page"
          >
            <ChevronsLeft className="h-4 w-4" />
          </Button>
        </PaginationItem>
        <PaginationItem>
          <PaginationPrevious
            className={page <= 1 ? 'pointer-events-none opacity-50' : ''}
            onClick={() => {
              if (page > 1) {
                onPageChange(page - 1)
              }
            }}
          />
        </PaginationItem>
        <PaginationItem>
          <span className="text-sm px-2">
            Page {page} / {pageCount}
          </span>
        </PaginationItem>
        <PaginationItem>
          <PaginationNext
            className={
              page >= pageCount ? 'pointer-events-none opacity-50' : ''
            }
            onClick={() => {
              if (page < pageCount) {
                onPageChange(page + 1)
              }
            }}
          />
        </PaginationItem>
        <PaginationItem>
          <Button
            variant="ghost"
            size="icon-sm"
            className={
              page >= pageCount ? 'pointer-events-none opacity-50' : ''
            }
            onClick={() => onPageChange(pageCount)}
            aria-label="Go to last page"
          >
            <ChevronsRight className="h-4 w-4" />
          </Button>
        </PaginationItem>
      </PaginationContent>
    </UIPagination>
  )
}
